import React from "react";
import { useLocation } from "react-router-dom";
import MainContentCard from "../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import PatientTimelineChild from "./PatientTimelineChild";

const PatientTimeline = () => {
  const { state } = useLocation();
  let patient = state;
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes page="PatientTimeline" route="/patient-timeline">
        <PatientTimelineChild pRecord={patient} />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default PatientTimeline;
